<template>
  <svg
    :width="size"
    :height="size"
    :viewBox="icons[name]?.viewBox || '0 0 24 24'"
    :fill="fill"
    :stroke="stroke"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    :class="[
      'base-icon',
      `icon-${name}`,
      ...(Array.isArray(customClass) ? customClass : [customClass])
    ]"
    v-html="icons[name]?.path.join('')"
  />
</template>

<script setup>
import { computed } from 'vue';
import { icons } from './iconPaths';

const props = defineProps({
  name: {
    type: String,
    required: true,
    validator: (value) => Object.keys(icons).includes(value)
  },
  size: {
    type: [Number, String],
    default: 24
  },
  customClass: {
    type: [String, Array, Object],
    default: ''
  },
  stroke: {
    type: String,
    default: 'currentColor'
  },
  strokeWidth: {
    type: [Number, String],
    default: 2
  },
  fill: {
    type: String,
    default: 'none'
  }
});

// Garante que o ícone existe antes de renderizar
const iconExists = computed(() => !!icons[props.name]);
</script>

<style scoped>
.base-icon {
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

/* Estilos padrão para garantir consistência */
.base-icon[stroke="currentColor"] {
  color: inherit;
}

.base-icon[fill="currentColor"] {
  fill: currentColor;
}

/* Previne flickering durante o carregamento */
.base-icon:not([width]) {
  width: 24px;
  height: 24px;
}
</style>